import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default {
  props: {
    navProps: {
      type: Object,
      default: function () {
        return { sticky: true }
      }
    }
  },

  render(h) {
    return (
      <div>
        <Nav sticky={this.navProps.sticky} />
        {/* <div class="bg-theme_orange text-center text-white md:h-12 h-24 border-t-2 border-b-2 border-white flex items-center mx-auto content-center">
        <div class="w-full">
        {this.$t('courses_page.new_courses')}
        </div>
        </div> */}
        { this.$slots.default }
        <Footer />
      </div>
    );
  }
}